function fallbackUuid(): `${string}-${string}-${string}-${string}-${string}` {
  const bytes = new Uint8Array(16);

  if (typeof globalThis.crypto?.getRandomValues === 'function') {
    globalThis.crypto.getRandomValues(bytes);
  } else {
    for (let index = 0; index < bytes.length; index += 1) {
      bytes[index] = Math.floor(Math.random() * 256);
    }
  }

  bytes[6] = (bytes[6] & 0x0f) | 0x40;
  bytes[8] = (bytes[8] & 0x3f) | 0x80;

  const hex = Array.from(bytes, (byte) => byte.toString(16).padStart(2, '0'));
  return `${hex.slice(0, 4).join('')}-${hex.slice(4, 6).join('')}-${hex.slice(6, 8).join('')}-${hex.slice(8, 10).join('')}-${hex.slice(10).join('')}`;
}

export function randomUuid(): `${string}-${string}-${string}-${string}-${string}` {
  if (typeof globalThis.crypto?.randomUUID === 'function') {
    return globalThis.crypto.randomUUID();
  }

  return fallbackUuid();
}

export function installRandomUuidFallback(): void {
  if (typeof globalThis.crypto?.randomUUID === 'function') return;

  const cryptoObject = globalThis.crypto ?? {};
  Object.defineProperty(cryptoObject, 'randomUUID', {
    configurable: true,
    value: fallbackUuid,
  });

  if (!globalThis.crypto) {
    Object.defineProperty(globalThis, 'crypto', {
      configurable: true,
      value: cryptoObject,
    });
  }
}
